import styled from 'styled-components';

export const PageLineContainer = styled.div`
  width: 100%;
  max-width: 1416px;
  margin-left: auto;
  margin-right: auto;

  h4 {
    font-weight: ${(props) => props.theme.font.title.weight.bold};
    color: ${(props) => props.theme.color.text.inverse};
    background: ${(props) => props.theme.color.ui.primary};
    display: inline-block;
    padding: 5px 16px;
    max-height: 35px;
  }

  p {
    width: 0px;
    height: 0px;
    border-style: solid;
    border-width: 35px 0 0 25px;
    border-color: transparent transparent transparent
      ${(props) => props.theme.color.ui.primary};
    transform: rotate(0deg);
    display: inline-block;
    position: relative;
    top: 12px;
  }

  @media screen and (max-width: 950px) {
    display: none;
  }
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background: ${(props) => props.theme.color.ui.primary};
`;
